import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { black1, green } from 'app/components/ThemeProvider/colors';

const TemplateFileIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 20 20" sx={{ height: '20px', width: '20px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M17.6271 9.08247L10.1141 16.5955C8.40556 18.304 5.63546 18.304 3.92692 16.5955C2.21837 14.8869 2.21837 12.1168 3.92692 10.4083L11.4399 2.89529C12.579 1.75626 14.4257 1.75626 15.5647 2.89529C16.7037 4.03432 16.7037 5.88105 15.5647 7.02008L8.34633 14.2385C7.77682 14.808 6.85345 14.808 6.28394 14.2385C5.71442 13.6689 5.71442 12.7456 6.28394 12.1761L12.6184 5.84157"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default TemplateFileIcon;
